/* ── Modal Dialog Custom Element ── */
class ModalDialog extends HTMLElement {
  connectedCallback() {
    this.closeButtons = this.querySelectorAll('[data-modal-close]');
    this.contentEl = this.querySelector('.modal__content');

    this.closeButtons.forEach(function (btn) {
      btn.addEventListener('click', this.close.bind(this));
    }.bind(this));

    this.addEventListener('keydown', this.onKeydown.bind(this));

    this.unsubscribeOpen = window.pubsub.subscribe('modal:open', this.onOpenEvent.bind(this));
    this.unsubscribeClose = window.pubsub.subscribe('modal:close', this.onCloseEvent.bind(this));
  }

  disconnectedCallback() {
    if (this.unsubscribeOpen) this.unsubscribeOpen();
    if (this.unsubscribeClose) this.unsubscribeClose();
  }

  onOpenEvent(data) {
    if (data && data.id === this.id) {
      this.triggerElement = data.trigger || document.activeElement;
      this.open();
    }
  }

  onCloseEvent(data) {
    if (!data || data.id === this.id) {
      this.close();
    }
  }

  open() {
    this.removeAttribute('hidden');
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';

    if (this.contentEl) {
      this.contentEl.focus();
    }

    this.trapFocus();
  }

  close() {
    this.setAttribute('hidden', '');
    this.removeAttribute('open');
    document.body.style.overflow = '';

    if (this.triggerElement && typeof this.triggerElement.focus === 'function') {
      this.triggerElement.focus();
    }

    window.pubsub.publish('modal:close', { id: this.id });
  }

  onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
    }

    if (e.key === 'Tab') {
      this.handleTabTrap(e);
    }
  }

  trapFocus() {
    this.focusableElements = this.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
  }

  handleTabTrap(e) {
    if (!this.focusableElements || this.focusableElements.length === 0) return;

    var first = this.focusableElements[0];
    var last = this.focusableElements[this.focusableElements.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
}

customElements.define('modal-dialog', ModalDialog);
